import {
  createMRTColumnHelper,
  useMantineReactTable,
  MRT_Table,
} from "mantine-react-table"
import { useMemo } from "react"

import { SelectCreatable } from "@costory/front/components/SelectCreatable"

export const TableMappingManual = ({
  selectedDataSource,
  availableDimensionValues,
  values,
  onMappingChange,
  onVdimValueCreate,
}: {
  selectedDataSource: {
    name: string
  }[]
  availableDimensionValues: string[]
  values: Record<string, string>
  onMappingChange: (value: { metricName: string; vdimValue: string }) => void
  onVdimValueCreate: (value: string) => void
}) => {
  const tableData = useMemo(
    () =>
      selectedDataSource
        ?.map(({ name }) => ({
          id: name,
          name,
          value: values[name] ?? "",
        }))
        .slice(0, 30) ?? [],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedDataSource],
  )
  const columnHelper = createMRTColumnHelper<{
    id: string
    name: string
    value: string
  }>()
  const table = useMantineReactTable({
    columns: [
      columnHelper.accessor("name", {
        header: "Metric Dimension",
      }),
      columnHelper.display({
        header: "Virtual Dimension Value",
        Cell: ({
          row: {
            original: { id },
          },
        }) => (
          <SelectCreatable
            withinPortal
            data={availableDimensionValues}
            value={values[id]}
            onChange={(value) =>
              onMappingChange({ metricName: id, vdimValue: value })
            }
            handleCreate={onVdimValueCreate}
            error={undefined}
          />
        ),
      }),
    ],
    data: tableData,
  })

  return <MRT_Table table={table} />
}
